import { BaseFilterOption } from './types';
import { config as geneConfig } from './gene';
import { config as geneSetsConfig } from './geneSets';
import { config as statusConfig } from './status';
import { config as cancerKnowledgeBaseConfig } from './jaxCKB';
import { config as selectedConfig } from './selected';
import { buildConfig as buildLabReportedSignificanceConfig } from './labReportedSignificance';

const labReportedSignificanceConfig = buildLabReportedSignificanceConfig();

export const copyNumberOptions: Array<Partial<BaseFilterOption>> = [
  { ...selectedConfig },
  { ...cancerKnowledgeBaseConfig },
  { ...geneSetsConfig },
  { ...geneConfig },
  { ...statusConfig },
  { ...labReportedSignificanceConfig },
];
